export default [
  {
    showLeftMenu: 0,
    code: "11",
    auth: false,
    pcode: "root",
    auths: [],
    type: 1,
    url: "/announcement",
    viewTemplate: "common-modules/layout/Layout",
    name: "采购公告",
    id: 11,
    isGroup: 0,
    keyword: "announcement",
    sons: [
      {
        showLeftMenu: 0,
        code: "111",
        auth: false,
        pcode: "11",
        auths: [],
        type: 1,
        url: "/announcement/announcementLists",
        viewTemplate: "",
        name: "采购公告",
        id: 2,
        isGroup: 0,
        keyword: "/announcement-index-announcementLists",
        sons: [
          {
            showLeftMenu: 0,
            code: "1111",
            auth: false,
            pcode: "111",
            auths: [],
            type: 1,
            url: "/announcement/announcementLists",
            viewTemplate: "common-modules/parent-view/index",
            name: "采购公告",
            id: 3,
            isGroup: 0,
            keyword: "announcement-announcement-list",
            sons: [
              {
                showLeftMenu: 0,
                code: "11111",
                auth: false,
                pcode: "1111",
                auths: [],
                type: 2,
                url: "/announcement/announcementLists/all",
                viewTemplate: "announcement/view/announcementLists/all.vue",
                name: "全部",
                id: 3,
                isGroup: 0,
                keyword: "announcement-announcementLists-all",
                sons: []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    showLeftMenu: 1,
    code: "1",
    auth: false,
    pcode: "root",
    auths: [],
    type: 1,
    url: "/electronicQuotation",
    viewTemplate: "common-modules/layout/Layout",
    name: "电子报价",
    id: 1,
    isGroup: 0,
    keyword: "electronicQuotation",
    sons: [
      {
        showLeftMenu: 1,
        code: "11",
        auth: false,
        pcode: "1",
        auths: [],
        type: 1,
        url: "/electronicQuotation/electronicQuotationLists",
        viewTemplate: "",
        name: "电子报价",
        id: 2,
        isGroup: 0,
        keyword: "/electronicQuotation-index-electronicQuotationLists",
        sons: [
          {
            showLeftMenu: 1,
            code: "111",
            auth: false,
            pcode: "11",
            auths: [],
            type: 1,
            url: "/electronicQuotation/electronicQuotationLists",
            viewTemplate: "common-modules/parent-view/index",
            name: "电子报价",
            id: 3,
            isGroup: 0,
            keyword: "electronicQuotation-electronicQuotation-list",
            sons: [
              {
                showLeftMenu: 0,
                code: "1111",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/electronicQuotation/electronicQuotationLists/pending",
                viewTemplate:
                  "electronicQuotation/views/electronicQuotationLists/pending.vue",
                name: "待报价",
                id: 3,
                isGroup: 0,
                keyword: "electronicQuotation-electronicQuotationList-spending",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1112",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/electronicQuotation/electronicQuotationLists/offer",
                viewTemplate:
                  "electronicQuotation/views/electronicQuotationLists/offer.vue",
                name: "已报价",
                id: 3,
                isGroup: 0,
                keyword: "electronicQuotation-electronicQuotationList-offer",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1113",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/electronicQuotation/electronicQuotationLists/lose",
                viewTemplate:
                  "electronicQuotation/views/electronicQuotationLists/lose.vue",
                name: "已失效",
                id: 3,
                isGroup: 0,
                keyword: "electronicQuotation-electronicQuotationList-lose",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1114",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url:
                  "/electronicQuotation/electronicQuotationDetail/detail/:id/:seekSupplierId",
                viewTemplate:
                  "electronicQuotation/views/electronicQuotationDetail/detail.vue",
                name: "详情",
                id: 3,
                isGroup: 0,
                keyword: "electronicQuotation-electronicQuotationDetail-detail",
                sons: []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    showLeftMenu: 1,
    code: "1",
    auth: false,
    pcode: "root",
    auths: [],
    type: 1,
    url: "/inquiry",
    viewTemplate: "common-modules/layout/Layout",
    name: "采购报价",
    id: 1,
    isGroup: 0,
    keyword: "inquiry",
    sons: [
      {
        showLeftMenu: 1,
        code: "11",
        auth: false,
        pcode: "1",
        auths: [],
        type: 1,
        url: "/inquiry/inquiryLists",
        viewTemplate: "",
        name: "电子报价",
        id: 2,
        isGroup: 0,
        keyword: "/inquiry-index-inquiryLists",
        sons: [
          {
            showLeftMenu: 1,
            code: "111",
            auth: false,
            pcode: "11",
            auths: [],
            type: 1,
            url: "/inquiry/inquiryLists",
            viewTemplate: "common-modules/parent-view/index",
            name: "电子报价",
            id: 3,
            isGroup: 0,
            keyword: "inquiry-inquiry-list",
            sons: [
              {
                showLeftMenu: 0,
                code: "1112",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/inquiry/inquiryLists/offer",
                viewTemplate: "inquiry/views/inquiryLists/offer.vue",
                name: "已报价",
                id: 3,
                isGroup: 0,
                keyword: "inquiry-inquiryLists-offer",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1113",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/inquiry/inquiryLists/lose",
                viewTemplate: "inquiry/views/inquiryLists/lose.vue",
                name: "已失效",
                id: 3,
                isGroup: 0,
                keyword: "inquiry-inquiryLists-lose",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1111",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/inquiry/inquiryLists/pending",
                viewTemplate: "inquiry/views/inquiryLists/pending.vue",
                name: "待报价",
                id: 3,
                isGroup: 0,
                keyword: "inquiry-inquiryLists-spending",
                sons: []
              },
              {
                showLeftMenu: 0,
                code: "1114",
                auth: false,
                pcode: "111",
                auths: [],
                type: 2,
                url: "/inquiry/inquiryDetail/detail",
                viewTemplate: "inquiry/views/inquiryDetail/detail.vue",
                name: "详情",
                id: 3,
                isGroup: 0,
                keyword: "inquiry-inquiryDetail"
              }
            ]
          }
        ]
      }
    ]
  },

  {
    showLeftMenu: 1,
    code: "3",
    auth: false,
    pcode: "root",
    auths: [],
    type: 1,
    url: "/notice",
    viewTemplate: "common-modules/layout/Layout",
    name: "通知公告",
    id: 11,
    isGroup: 0,
    keyword: "notice",
    sons: [
      {
        showLeftMenu: 1,
        code: "31",
        auth: false,
        pcode: "3",
        auths: [],
        type: 1,
        url: "/notice/noticeList",
        viewTemplate: "",
        name: "通知公告",
        id: 2,
        isGroup: 0,
        keyword: "/notice-index-noticeList",
        sons: [
          {
            showLeftMenu: 1,
            code: "311",
            auth: false,
            pcode: "31",
            auths: [],
            type: 1,
            url: "/notice/noticeList",
            viewTemplate: "common-modules/parent-view/index",
            name: "通知公告",
            id: 3,
            isGroup: 0,
            keyword: "notice-list",
            sons: [
              {
                showLeftMenu: 1,
                code: "3111",
                auth: false,
                pcode: "3111",
                auths: [],
                type: 2,
                url: "/notice/noticeList/all",
                viewTemplate: "notice/views/all.vue",
                name: "全部",
                id: 3,
                isGroup: 0,
                keyword: "notice-noticeList-all",
                sons: []
              }
            ]
          }
        ]
      }
    ]
  }
];
